import { PartnerType } from "@/app/utils/partners.enum";
import { AuthorizationStatusEnum } from "../authorizationService/getAuthorization";
import { httpClient } from "../http/httpClient";

export type PreAnalysisRequest = {
  name: string;
  cpf: string;
  birthDate: string;
  phone: string;
  email: string;
  endereco: {
    logradouro: string;
    bairro: string;
    cep: string;
    cidade: string;
    uf: string;
  };
  diaRecebimentoId?: number;
  observation?: string;
};

export type PreAnalysisResponse = {
  id: string;
  status: AuthorizationStatusEnum;
  processoId: string;
  propostaId: string | null;
  aprovado: boolean | null;
  processando: boolean;
  autorizacaoEnviada: boolean;
  produtoId: string | null;
  tabelaJurosId: string | null;
  diaRecebimentoId: number | null;
  valorRendaPresumida: number | null;
  mensagem: string;
  mensagens: string[];
};

export async function postPreAnalysis(
  payload: PreAnalysisRequest,
): Promise<PreAnalysisResponse> {
  const { data } = await httpClient
    .post<PreAnalysisResponse>("/crefaz-clt/pre-analysis", payload, {
      journey: PartnerType.CREFAZ_CLT,
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
